import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, TrendingUp, Map, UserCheck } from 'lucide-react';

interface NavigationDropdownProps {
  currentBoard: any;
  onActivityClick: () => void;
  onRoadmapsClick: () => void;
  onResourceManagerClick: () => void;
}

const NavigationDropdown: React.FC<NavigationDropdownProps> = ({
  currentBoard,
  onActivityClick,
  onRoadmapsClick,
  onResourceManagerClick,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!currentBoard) return null;

  const menuItems = [
    ...(currentBoard.boardType !== 'resource_manager' ? [{
      icon: UserCheck,
      label: 'Resource Manager',
      onClick: () => {
        onResourceManagerClick();
        setIsOpen(false);
      },
    }] : []),
    {
      icon: TrendingUp,
      label: 'Activity',
      onClick: () => {
        onActivityClick();
        setIsOpen(false);
      },
    },
    {
      icon: Map,
      label: 'Roadmaps',
      onClick: () => {
        onRoadmapsClick();
        setIsOpen(false);
      },
    },
  ];

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 hover:text-satsuma-600 transition-colors rounded-lg hover:bg-white/15"
      >
        <span>More</span>
        <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: -10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: -10 }}
            className="absolute top-full left-0 mt-2 w-56 bg-white rounded-2xl border border-gray-200 shadow-xl z-50"
          >
            <div className="p-2">
              {menuItems.map((item, index) => {
                const Icon = item.icon;
                return (
                  <button
                    key={index}
                    onClick={item.onClick}
                    className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors text-left"
                  >
                    <Icon size={18} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NavigationDropdown;

